import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const ChecklistItem = ({ fields }) => (
  <li className="vds-checklist__list-item">
    <Text tag="h5" field={fields.title} />
    <Text field={fields.text} />
  </li>
);

export default ChecklistItem;
